// User Action Types
export const SET_USER_DATA = "USER_SET_DATA";
export const REMOVE_USER_DATA = "USER_REMOVE_DATA";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";
export const GET_USER_BY_USERNAME = "GET_USER_BY_USERNAME";
export const GET_ACCOUNT_BY_USERNAME = "GET_ACCOUNT_BY_USERNAME";
export const USER_LOADING = "USER_LOADING";

// Login Action Types
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_LOADING = "LOGIN_LOADING";
export const LOGIN_CLEAR = "LOGIN_CLEAR";
export const LOADING_CLEAR = "LOADING_CLEAR";
export const LOGIN_ERROR_SESSION_ACTIVE = "LOGIN_ERROR_SESSION_ACTIVE";
export const CA_SET_ERROR = "CA_SET_ERROR";